import { Route, useHistory, useLocation } from "react-router";

import { IRoute } from "@interfaces";
import { AuthLayout } from "@layouts";
import {
  PATH_HOME,
  PATH_LOGIN,
  PATH_REDEEM_COUPON,
  adminRoutes,
  authRoutes,
  clinicRoutes,
  enumSubdomain,
} from "@configs";
import { useNotify } from "@utils";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { logout, selectAuth } from "src/Redux/Slices/auth";
import { useEffect, useState } from "react";
import { selectApp, updateDoamin } from "@redux";
import { Spin } from "antd";
import styled from "styled-components";

export const ComponentAppRoute = (props: IRoute) => {
  //page props
  const { path, exact } = props;
  const history = useHistory();
  const { warning } = useNotify();
  const { pathname } = useLocation();
  const { hostname } = window.location;
  const token = useSelector(selectAuth)?.auth?.token;
  const { domain } = useSelector(selectApp);
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(true);

  const isAuthRoute = authRoutes.find((item: string) => item === pathname);

  useEffect(() => {
    updateSubdomain();
    setTimeout(() => {
      setLoading(false);
    }, 500);
  }, [hostname]);

  const subdomain = hostname.split(".")[0] as enumSubdomain;

  // update subdomain
  const updateSubdomain = async () => {
    if (domain !== subdomain) {
      await dispatch(updateDoamin(subdomain));
    }
  };

  const checkAuth = () => {
    // has token and auth route    
    if (token && isAuthRoute) {      
      history.push(PATH_HOME);
    } else {
      dispatch(logout);
    }
  };
  useEffect(() => {
    checkAuth();
  }, [token]);

  useEffect(() => {
    if (!token && !isAuthRoute) history.push(PATH_LOGIN);
  }, [token]);

  // useEffect(() => {
  //   adminOrClinic();
  // }, [hostname, pathname]);

  // const isAdmin = () => domain === enumSubdomain.ADMIN || domain === enumSubdomain.LOCALHOST;
  // const isClinic = () => domain === enumSubdomain.CLINIC;
  // const isClinicRoutes = () => clinicRoutes.find((route) => route === pathname);
  // const isAdminRoutes = () => adminRoutes.find((route) => route === pathname);
  // const adminOrClinic = async () => {
  //   console.log("check" + isClinicRoutes());
  //   if (isClinic() && !isClinicRoutes()) {
  //     await dispatch(logout());
  //   }
  //   if (isAdmin() && !isAdminRoutes()) {
  //     await dispatch(logout());
  //   }
  // };

  const Component = props.component;
  const Layout = props.layout || AuthLayout;
  if (token === undefined && loading) {
    return (
      <StyledDiv>
        <Spin spinning={loading} tip="Loading..." />
      </StyledDiv>
    );
  }
  return (
    <Route
      path={path}
      exact={exact}
      render={() => (
        <Layout>
          <Component />
        </Layout>
      )}
    />
  );
};
const StyledDiv = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100vh;
`;